import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {Observable} from 'rxjs';
import {
  citizenGetServicesAutomationDetails
} from 'src/app/store/entities/citizens/citizens-services-automation-details/citizens-services-automation-details.actions';
import {
  CitizensServicesAutomationDetails
} from 'src/app/store/entities/citizens/citizens-services-automation-details/citizens-services-automation-details.model';
import {
  selectModifiedCitizenServicesAutomation
} from 'src/app/store/entities/citizens/citizens-services-automation-details/citizens-services-automation-details.selectors';
import {
  citizenGetServicesDeliveryChannels
} from 'src/app/store/entities/citizens/citizens-services-delivery-channel/citizens-services-delivery-channel.actions';
import {
  CitizensServicesDeliveryChannel
} from 'src/app/store/entities/citizens/citizens-services-delivery-channel/citizens-services-delivery-channel.model';
import {
  selectCitizenServiceDeliveryChannel
} from 'src/app/store/entities/citizens/citizens-services-delivery-channel/citizens-services-delivery-channel.selectors';
import {
  citizenGetServicesRequirements
} from 'src/app/store/entities/citizens/citizens-services-requirements/citizens-services-requirements.actions';
import {
  CitizensServicesRequirements
} from 'src/app/store/entities/citizens/citizens-services-requirements/citizens-services-requirements.model';
import {
  selectModifiedServiceRequirement
} from 'src/app/store/entities/citizens/citizens-services-requirements/citizens-services-requirements.selectors';
import {citizenGetServices} from 'src/app/store/entities/citizens/citizens-services/citizens-services.actions';
import {CitizensServices} from 'src/app/store/entities/citizens/citizens-services/citizens-services.model';
import {
  selectModifiedCitizensByServiceUniqueId
} from 'src/app/store/entities/citizens/citizens-services/citizens-services.selectors';
import {AppState} from 'src/app/store/reducers';
import {CITIZEN_UPADATE_POPULAR_SERVICE} from '../../../service-view/popular-service';
import {environment} from 'src/environments/environment.prod';
import {Router} from "@angular/router";

@Component({
  selector: 'app-portal-popular-services-view-details',
  templateUrl: './portal-popular-services-view-details.component.html',
  styleUrl: './portal-popular-services-view-details.component.scss'
})
export class PortalPopularServicesViewDetailsComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<PortalPopularServicesViewDetailsComponent>);
  private readonly store = inject(Store<AppState>);
  private readonly apollo = inject(Apollo);
  private readonly router = inject(Router);
  readonly data: { service: CitizensServices } = inject(MAT_DIALOG_DATA);

  fileServer: string = environment.FILE_SERVER_URL;
  serviceUniqueId: string;

  socialMediaLinks = [
    {name: 'Instagram', icon: 'instagram_coloured', link: 'https://www.instagram.com'},
    {name: 'X', icon: 'x', link: 'https://x.com'},
    {name: 'Youtube', icon: 'youtube_coloured', link: 'https://www.youtube.com'},
    {name: 'Oxygen', icon: 'oxygen', link: 'https://www.maadili.go.tz'}
  ];

  service$: Observable<CitizensServices>;
  requirements$: Observable<CitizensServicesRequirements[]>;
  servicesAutomations$: Observable<CitizensServicesAutomationDetails[]>;
  deliveryChannels$: Observable<CitizensServicesDeliveryChannel[]>;

  constructor() {
    this.serviceUniqueId = this.data?.service?.serviceUniqueId;
    this.getData();
  }

  ngOnInit() {
    this.citizenUpdatePopularServiceMutation();

    this.service$ = this.store.select(selectModifiedCitizensByServiceUniqueId(this.serviceUniqueId));
    this.servicesAutomations$ = this.store.select(selectModifiedCitizenServicesAutomation);
    this.deliveryChannels$ = this.store.select(selectCitizenServiceDeliveryChannel);
    this.requirements$ = this.store.select(selectModifiedServiceRequirement);
  }

  closeModal(close: boolean): void {
    if (close) {
      this.dialogRef.close();
    }
  }

  getData() {
    this.store.dispatch(citizenGetServicesRequirements({serviceUniqueId: this.serviceUniqueId}));
    this.store.dispatch(citizenGetServices({
      filtering: {
        serviceUniqueId: this.serviceUniqueId,
        pageNumber: 1,
        itemsPerPage: 1
      }
    }));
    this.store.dispatch(citizenGetServicesAutomationDetails({filtering: {serviceUniqueId: this.serviceUniqueId}}));
    this.store.dispatch(citizenGetServicesDeliveryChannels({serviceUniqueId: this.serviceUniqueId}));
  }

  citizenUpdatePopularServiceMutation() {
    this.apollo.mutate({
      mutation: CITIZEN_UPADATE_POPULAR_SERVICE,
      fetchPolicy: 'network-only',
      variables: {serviceUniqueId: this.serviceUniqueId}
    }).toPromise().then(() => {});
  }

  protected openServiceDetails() {
    this.dialogRef.close();
    this.router.navigate(['/service-view', this.data?.service?.serviceUniqueId]);
  }
}
